<template>
  <el-popover
    placement="bottom-start"
    v-model="visible"
    width="400"
    trigger="click"
    class="m-l-10 m-r-10"
    :visible-arrow="false"
  >
    <div class="high-search advanced-query">
      <ly-form :formConfig="formConfig" :formKeys="formKeys" ref="lyForm"></ly-form>
      <div class="btn-group">
        <el-button size="medium" @click="reset">重置</el-button>
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <el-button slot="reference" type="primary" :size="size || 'medium'">
      高级查询
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
  </el-popover>
</template>
<script>
import { Popover } from 'element-ui';
import { specializedSearchForm } from '@/utils/formConfigCommon';
import LyForm from '@/components/LyForm';

export default {
  name: 'AdvancedQuery',
  components: {
    ElPopover: Popover,
    LyForm
  },
  props: {
    size: {
      type: String
    },
    // 是否需要级别
    ifLevel: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      // formKeys: specializedSearchForm,
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      visible: false
    };
  },
  computed: {
    formKeys() {
      const tmp = { ...specializedSearchForm };
      if (this.ifLevel) return tmp;
      delete tmp.fee_level_id;
      return tmp;
    }
  },
  methods: {
    async search() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        data.specialized_subject_id = data.specialized_subject_id || data.specialized_subject_id_parent;
        delete data.specialized_subject_id_parent;
        delete data.specialized_subject_name;
        delete data.org_name;
        this.$emit('search', { ...data });
      }
      this.visible = false;
    },
    async reset() {
      this.$refs.lyForm.resetFields();
      const data = {};
      Object.keys(this.formKeys).map(key => {
        if (key) data[key] = '';
        return key;
      });
      this.$emit('search', data);
    }
  }
};
</script>
<style lang="less">
.advanced-query.high-search {
  .btn-group {
    display: flex;
    justify-content: space-between;
  }
  .el-input__validateIcon {
    display: none;
  }
}
</style>
